import { render, staticRenderFns } from "./ChevronIcon.vue?vue&type=template&id=411971a9&"
import script from "./ChevronIcon.vue?vue&type=script&lang=ts&"
export * from "./ChevronIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports